import { Pipe, PipeTransform } from "@angular/core";

/**
 * Pipe para comparar dois objetos  por suas propriedades de primeiro nível.
 * Retorna true se os objetos possuem as mesmas chaves e os valores correspondentes são estritamente iguais.
 */
@Pipe({ name: "compareFlatObject" })
export class CompareFlatObjectPipe implements PipeTransform {
    transform(obj1: Object | null | undefined, obj2: Object | null | undefined): boolean {

        if (!obj1 || !obj2) {
            return obj1 === obj2;
        }

        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length !== keys2.length) {
            return false;
        }

        for (const key of keys1) {
            if (!Object.prototype.hasOwnProperty.call(obj2, key)) {
                return false;
            }

            if (obj1[key] !== obj2[key]) {
                return false;
            }
        }

        return true;
    }
}
